export type AuthState = {
    isSocratic: boolean
};

export const initState: AuthState = {
    isSocratic: false
};
